import { render, staticRenderFns } from "./form-add-update-relationship.vue?vue&type=template&id=5bd40e09&scoped=true"
import script from "./form-add-update-relationship.vue?vue&type=script&lang=js"
export * from "./form-add-update-relationship.vue?vue&type=script&lang=js"
import style0 from "./form-add-update-relationship.vue?vue&type=style&index=0&id=5bd40e09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd40e09",
  null
  
)

export default component.exports